import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Segment,
  Image,
  Button,
  Dropdown,
  Modal,
  List,
} from 'semantic-ui-react';
import 'rc-slider/assets/index.css';
import { uiActions } from '../../actions/index';
import Strings from '../../common/Strings';
import '../Common.css';
import '../activity/ActivityToday.css';
import '../projects/ProjectDetails.css';
import './WorkLogsPerDay.css';
import {
  getFormattedStartTimestamp,
  getLoggedTimeFromMillis,
} from '../../helpers/workLog';
import { getProjectWithId } from '../../helpers/project';
import { sortWorkLogsByStartTimestamp } from '../../helpers/sort';

const moment = require('moment');

class WorkLogsPerDay extends React.Component {
  onAddNewLogClicked = () => {
    this.props.dispatch(uiActions.activityAddTimeClicked(this.props.project));
  };

  onWorkLogClicked = workLog => {
    const project = getProjectWithId(workLog.projectId);
    this.props.dispatch(uiActions.activityAddTimeClicked(project, workLog));
  };

  close = () => {
    this.props.dispatch(uiActions.workLogBlockClicked());
  };

  renderList(workLogs) {
    const sortedList = workLogs.asMutable();
    sortWorkLogsByStartTimestamp(sortedList);
    const Children = sortedList.map((workLog, index) => {
      const project = getProjectWithId(workLog.projectId);
      return (
        <List.Item
          className="project-list-item"
          style={{ position: 'relative' }}
          key={workLog.id}
          onClick={() => this.onWorkLogClicked(workLog)}
        >
          <div
            style={{
              position: 'absolute',
              left: 16.5,
              top: index === 0 ? 25 : -10,
              bottom: -10,
              width: 1,
              backgroundColor: '#E0E0E0',
            }}
          />
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'row',
              margin: 0,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexShrink: '0',
                width: 14,
                height: 14,
                borderRadius: 7,
                backgroundColor: project.color,
                marginRight: 10,
                marginTop: 15,
              }}
            />
            <div style={{ flexGrow: 1 }}>
              <p className="activity-today-list-item-timestamp">
                {getFormattedStartTimestamp(workLog)}
              </p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <p className="activity-today-list-item-title-dark">
                  {project.name}
                </p>
                <div style={{ flexGrow: 1 }} />
                <p className="activity-today-list-item-title-dark">
                  {getLoggedTimeFromMillis(workLog.totalLoggedMillis)}
                </p>
              </div>
              {workLog.notes && (
                <p className="activity-today-list-item-notes">
                  {workLog.notes}
                </p>
              )}
            </div>
          </div>
        </List.Item>
      );
    });

    const Footer = (
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            left: 16.5,
            top: -10,
            bottom: 12,
            width: 1,
            backgroundColor: '#E0E0E0',
          }}
        />
        <Image className="activity-today-list-bed-image" src="/emoji/bed.png" />
      </div>
    );

    return (
      <div className="activity-today-list">
        {Children}
        {Footer}
      </div>
    );
  }

  render() {
    const { color, name } = this.props.project;
    const { workLogs } = this.props;
    let date = moment();
    if (workLogs.length > 0) {
      date = moment(workLogs[0].date);
    }
    return (
      <div className="project-details-root">
        <div className="project-details-content-container">
          <Segment basic className="project-details-content">
            <div className="project-details-title-container">
              <h1 id="add-time-title-text" className="project-details-title">
                {Strings.WORK_LOGS_PER_DAY.projectTimeline}
              </h1>
            </div>
            <div id="logs-project-name-container">
              <div id="logs-project-color" style={{ backgroundColor: color }} />
              <h1 id="logs-project-name">{name}</h1>
              <div style={{ flexGrow: 1 }} />
              <Button
                className="common-green-button"
                onClick={() => this.onAddNewLogClicked()}
              >
                {Strings.WORK_LOGS_PER_DAY.addNewLog}
              </Button>
            </div>
            <div className="project-details-divider" />
            <p id="logs-date">{date.format('dddd MMM D, YYYY')}</p>
            {this.renderList(workLogs)}
          </Segment>
        </div>
        <Image
          id="add-time-close-button"
          src="/icon/close.svg"
          onClick={this.close}
        />
      </div>
    );
  }
}

WorkLogsPerDay.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    ownerUid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    archivedAt: PropTypes.string,
    hourlyRate: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }).isRequired,
  workLogs: PropTypes.arrayOf(
    PropTypes.shape({
      totalLoggedMillis: PropTypes.number.isRequired,
      projectId: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      startTimestamp: PropTypes.string,
      notes: PropTypes.string,
    }),
  ).isRequired,
};

const mapStateToProps = state => ({
  project: state.uiState.workLogsPerDayProject,
  workLogs: state.uiState.workLogsPerDay,
});

export default connect(mapStateToProps)(WorkLogsPerDay);



// WEBPACK FOOTER //
// ./src/components/activity/WorkLogsPerDay.js